class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

// Digit-only searches (e.g. "707") can't match model codes like "K707" without
// an OR-expanded q param, which is too ugly to keep in the address bar. The URL
// stays ?q=707 and the product grid is re-rendered in the background with the
// expanded query via the Section Rendering API — same Liquid cards, no API token.
(function () {
  const params = new URLSearchParams(window.location.search);
  const query = (params.get('q') || '').trim();
  if (!/^\d+$/.test(query)) return;
  if (typeof SearchForm === 'undefined' || !SearchForm.expandDigitQuery) return;

  const grid = document.getElementById('product-grid');
  const container = document.getElementById('ProductGridContainer');
  if (!grid || !container || !grid.dataset.id) return;

  const expanded = SearchForm.expandDigitQuery(query);
  const fetchParams = new URLSearchParams(window.location.search);
  fetchParams.set('q', expanded);
  fetchParams.set('options[prefix]', 'last');
  fetchParams.set('section_id', grid.dataset.id);

  fetch(`${window.location.pathname}?${fetchParams.toString()}`)
    .then((response) => (response.ok ? response.text() : Promise.reject(new Error(`HTTP ${response.status}`))))
    .then((text) => {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newContainer = doc.getElementById('ProductGridContainer');
      if (!newContainer) return;
      container.innerHTML = newContainer.innerHTML;

      // Inline scripts (card colour swatches) don't execute via innerHTML — re-create them
      container.querySelectorAll('script').forEach((inert) => {
        const script = document.createElement('script');
        script.textContent = inert.textContent;
        inert.replaceWith(script);
      });

      // Sync the "N results found" line and empty-state styling with the swapped grid
      const newStatus = doc.querySelector('.template-search__header p[role="status"]');
      const status = document.querySelector('.template-search__header p[role="status"]');
      if (status && newStatus) status.textContent = newStatus.textContent;
      const hasResults = !!container.querySelector('.grid__item');
      document.querySelector('.template-search')?.classList.toggle('template-search--empty', !hasResults);

      // Filter/sort requests rebuild the URL from the facet forms' hidden q input,
      // so point those at the expanded query to keep the results consistent
      document.querySelectorAll('facet-filters-form input[name="q"]').forEach((input) => {
        input.value = expanded;
      });

      if (window.videoViewportControl) window.videoViewportControl.refresh();
    })
    .catch((error) => console.debug('Model-code search expansion failed:', error));
})();
